import * as types from '../mutation-types'
// import auth from './auth'
import axios from 'axios'

// state
export const state = {
  cart: '0'
}

// getters
export const getters = {
  cart: state => state.cart
}

// mutations
export const mutations = {
  SET_CART (state,  id ) {
    // if (window.localStorage.getItem('cart')) {
    //   state.cart = JSON.parse(window.localStorage.getItem('cart')).length
    // } else {
    //   state.cart = 0
    // }
    const postData = {
      id: id
    }
    console.log(postData)
    axios.post('/api/getCart', postData).then(response => {
      if (response.status === 200 || response.status === 201) {
        state.cart = response.data.length
      } 
    })
  }
}

// actions
export const actions = {
  async setCart ({ commit }, obj) {
    commit('SET_CART', obj)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/cart-storage.js